export default class VideoFadeOut {
    constructor(options = {}) {
        this.options = {
            wrapperSelector: '[data-video-wrapper]',
            fadeOutClass: 'fade-out',
            onFadeOut: null, // Callback function when video fades out
            ...options
        };

        this.videoWrappers = [];
        this.eventHandlers = [];
        
        this.init();
    }

    init() {
        const videoWrappers = document.querySelectorAll(this.options.wrapperSelector);

        videoWrappers.forEach(wrapper => {
            const video = wrapper.querySelector('video');

            if (!video) return;

            const handleVideoEnd = () => {
                video.classList.add(this.options.fadeOutClass);
                
                // Call callback after fade out transition completes
                setTimeout(() => {
                    if (this.options.onFadeOut && typeof this.options.onFadeOut === 'function') {
                        this.options.onFadeOut();
                    }
                }, 250); // Match the CSS transition duration
            };

            video.addEventListener('ended', handleVideoEnd);
            
            // Store references for cleanup
            this.videoWrappers.push({
                wrapper,
                video,
                handler: handleVideoEnd
            });
        });
    }

    destroy() {
        this.videoWrappers.forEach(({ video, handler }) => {
            video.removeEventListener('ended', handler);
        });

        this.videoWrappers = [];
    }
}

